import api from "../api";

export const ParentLoginCheck = async (username, password) => {
  try {
    const response = await api.post("/api/v1/parent/login", { username, password });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const ParentGetAttendance = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/attendance/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetGrades = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/grades/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetGradesMonthlyProgress = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/grades/monthly/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetBehaviors = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/behaviors/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetTeacherEvaluations = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/evaluations/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const parentGetSupervisorNotes = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/supervisor-notes/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetStudentPoints = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/points/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetSchoolNews = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/news/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const ParentGetTeachers = async (token, studentId) => {
  try {
    const response = await api.get(`/api/v1/parent/teachers/${studentId}`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};